import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FollowupListComponent } from './followup-list/followup-list.component';
import { AuthGuard } from '../../../core/auth';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    path: '',
    component: FollowupListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FollowupRoutingModule {}
